import { useEffect, useState } from "react";
import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { TbArrowDownLeft, TbArrowUpRight, TbClock } from "react-icons/tb";
import { CircularProgress } from "@mui/material";
import { SummaryCard } from "../../../../../Components/Atoms/SummaryCard";
import useCallAxios from "../../../../../Hooks/useCallAxios";
import { formatCurrency } from "../../../../../Utils/formatters";

export const PixSalesSummaryCards = () => {
  const [dataCard, setDataCard] = useState(null);

  const {
    fetchGET: fetchPixCards,
    requestLoading: loading,
    requestData: dataPixCards,
  } = useCallAxios({ context: "pixCards", responseType: "" });

  useEffect(() => {
    fetchPixCards({});
  }, []);

  useEffect(() => {
    const dataPix = dataPixCards;
    setDataCard(dataPix?.data);
  }, [dataPixCards]);

  const dateLabel = format(new Date(), "d 'de' MMMM 'de' yyyy", { locale: ptBR });

  if (loading.GET) {
    return (
      <div className="mb-5 flex items-center justify-center py-8">
        <CircularProgress size={28} />
      </div>
    );
  }

  return (
    <section className="mb-5">
      <p className="mb-3 text-xs text-gray-500">Resumo de {dateLabel}</p>
      <div className="dashboard-card-grid dashboard-card-grid-pix">
        <SummaryCard
          icon={TbArrowDownLeft}
          title="Valor recebido"
          value={formatCurrency(dataCard?.total_received_amount)}
          footer={<p className="mt-2 text-xs text-gray-500">Total recebido hoje</p>}
        />
        <SummaryCard
          icon={TbArrowUpRight}
          title="Valor pago"
          value={formatCurrency(dataCard?.total_paid_amount)}
          footer={<p className="mt-2 text-xs text-gray-500">Total pago hoje</p>}
        />
        <SummaryCard
          icon={TbClock}
          title="Previsto para recebimento"
          value={formatCurrency(dataCard?.pending_receive_amount)}
          footer={<p className="mt-2 text-xs text-gray-500">Aguardando confirmação</p>}
        />
      </div>
    </section>
  );
};
